module.exports = __webpack_public_path__ + "static/media/backsplash3.6948266e.jpg";